// Temporary instrumentation for the first-click defect.
//
// The fix that shipped was built on a hypothesis — a late default overwriting an
// early click — and the browser says the defect survived it. So this records
// what actually happens instead of what is supposed to: when the init effect
// runs and which of its dependencies moved, the order the five requests come
// back in, every transition of `selection`, and every time the sidebar's user
// list changes shape.
//
// Off unless asked for: ?trace=1 in the URL, or localStorage vs_trace = "1".
// Nothing is sent anywhere. window.vsTrace() prints it; window.vsTraceDump()
// returns it as text to paste.

const CAP = 500;              // a ring: a long session must not grow without end
let buffer = [];
let enabled = null;           // resolved once, lazily
let t0 = 0;

export function traceEnabled() {
  if (enabled !== null) return enabled;
  enabled = false;
  try {
    const q = new URLSearchParams(window.location.search).get("trace");
    if (q === "1") localStorage.setItem("vs_trace", "1");
    if (q === "0") localStorage.removeItem("vs_trace");
    enabled = localStorage.getItem("vs_trace") === "1";
  } catch { enabled = false; }
  if (enabled) {
    t0 = Date.now();
    install();
    trace("boot", { bundle: bundleName(), url: window.location.href });
  }
  return enabled;
}

/** Which of a dependency list changed identity since last time. The question
 *  behind "did this effect re-run, and why". */
export function whatChanged(previous, current, names) {
  if (!previous) return ["(first run)"];
  const out = [];
  for (let i = 0; i < current.length; i++) {
    if (!Object.is(previous[i], current[i])) out.push(names[i] || `#${i}`);
  }
  return out.length ? out : ["(nothing — re-run without a changed dep)"];
}

export function bundleName() {
  try {
    const el = document.querySelector('script[src*="/static/js/main."]');
    return el ? el.src.split("/").pop() : "(unknown)";
  } catch { return "(unknown)"; }
}

export function trace(event, data) {
  if (!traceEnabled()) return;
  const row = { ms: Date.now() - t0, event, ...(data || {}) };
  buffer.push(row);
  if (buffer.length > CAP) buffer = buffer.slice(-CAP);
  // eslint-disable-next-line no-console
  console.debug(`[vs +${row.ms}ms] ${event}`, data || "");
}

export function traceRows() {
  return buffer.slice();
}

export function traceText() {
  return buffer.map((r) => {
    const { ms, event, ...rest } = r;
    return `+${String(ms).padStart(6)}ms  ${event.padEnd(26)} ${JSON.stringify(rest)}`;
  }).join("\n");
}

function install() {
  try {
    window.vsTrace = () => { console.table(buffer); return buffer.length; };
    window.vsTraceDump = () => traceText();
    window.vsTraceClear = () => { buffer = []; t0 = Date.now(); };
  } catch { /* nothing to hang it on */ }
}

// Test seam: the module keeps state, and a test needs to start from nothing.
export function __resetTrace(force = null) {
  buffer = [];
  enabled = force;
  t0 = Date.now();
}
